import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { Modal } from 'antd';

const propTypes = {
  headerText: PropTypes.string,
  messageText: PropTypes.string,
  cancelButtonText: PropTypes.string,
  submitButtonText: PropTypes.string,
  onHide: PropTypes.func,
  onSubmit: PropTypes.func,
};
const defaultProps = {
  headerText: 'Do you really want to remove the file?',
  messageText: 'Message',
  cancelButtonText: 'Cancel',
  submitButtonText: 'OK',
  autofocus: false,
  onHide: () => {},
  onSubmit: () => {},
};

export default class ConfirmDialog extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    if (this.ref) {
      this.ref.focus();
    }
  }

  handleKeyDown = async (e) => {
    if (e.which === 13) {
      // Enter key
      this.handleSubmit();
    }
  };

  handleSubmit = async () => {
    this.props.onSubmit();
  };

  render() {
    const { onHide, onSubmit, headerText, messageText, submitButtonText, cancelButtonText, rootContainer } = this.props;

    return (
      <Modal
        title={headerText}
        getContainer={rootContainer}
        open={true}
        onCancel={onHide}
        okText={submitButtonText}
        cancelText={cancelButtonText}
        onOk={onSubmit}
      >
        {messageText}
      </Modal>
    );
  }
}

ConfirmDialog.propTypes = propTypes;
ConfirmDialog.defaultProps = defaultProps;
